import { render, staticRenderFns } from "./HealthInstitutionComp.vue?vue&type=template&id=6f295c19&scoped=true"
import script from "./HealthInstitutionComp.vue?vue&type=script&lang=js"
export * from "./HealthInstitutionComp.vue?vue&type=script&lang=js"
import style0 from "./HealthInstitutionComp.vue?vue&type=style&index=0&id=6f295c19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f295c19",
  null
  
)

/* custom blocks */
import block0 from "./HealthInstitutionComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports